enum Themes {
  LIGHT = "light",
  DARK = "dark",
}

export default Themes
